import { styled, Switch, SwitchProps } from '@mui/material';

import { black, grayColors, primaryColors } from '~components/theme/styles/colors';

interface LabeledSwitchProps {
  onText?: string;
  offText?: string;
  onColor?: string;
  offColor?: string;
  textOnColor?: string;
  textOffColor?: string;
}

export const LabeledSwitch = styled(
  (props: SwitchProps) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />,
  {
    shouldForwardProp: prop =>
      prop !== 'onText' &&
      prop !== 'offText' &&
      prop !== 'onColor' &&
      prop !== 'offColor' &&
      prop !== 'textOnColor' &&
      prop !== 'textOffColor',
  },
)<LabeledSwitchProps>(
  ({
    theme,
    checked,
    onText = ' ',
    offText = ' ',
    onColor = grayColors[900],
    offColor = grayColors[900],
    textOnColor = primaryColors[100],
    textOffColor = primaryColors[900],
    size = 'medium',
  }) => ({
    width: size === 'medium' ? 60 : 54,
    height: size === 'medium' ? 30 : 24,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      transitionDuration: '200ms',
      color: offColor,
      background: offColor,
      '&.Mui-checked': {
        transform: 'translateX(29.5px)',
        color: onColor,
        background: onColor,
        '& .MuiSwitch-thumb:before': {
          content: `"${onText}"`,
        },
        '& + .MuiSwitch-track': {
          backgroundColor: grayColors[900],
          opacity: 1,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600],
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      border: '1px solid rgba(255, 255, 255, 0.15)',
      background: checked && onColor ? onColor : black['85%'],
      width: size === 'medium' ? 30 : 24,
      height: size === 'medium' ? 30 : 24,
      '&:before, &:after': {
        content: '""',
        fontSize: 11,
        position: 'absolute',
        transform: 'translateY(-50%)',
        width: 18,
        height: 16,
        color: primaryColors[100],
      },
      '&:before': {
        color: primaryColors[100],
        content: `"${offText}"`,
        top: 8,
        left: 8,
      },
    },
    '& .MuiSwitch-track': {
      borderRadius: 32 / 2,
      border: '1px solid rgba(255, 255, 255, 0.15)',
      backgroundColor: grayColors[900],
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
      '&:before, &:after': {
        content: '""',
        fontSize: 11,
        position: 'absolute',
        transform: 'translateY(-50%)',
        width: 18,
        height: 16,
      },
      '&:before': {
        color: textOffColor,
        content: `"${offText}"`,
        top: 8,
        left: 7,
      },
      '&:after': {
        color: textOnColor,
        content: `"${onText}"`,
        top: 8,
        right: 4,
      },
    },
  }),
);
